import { render, staticRenderFns } from "./EmptyTable.vue?vue&type=template&id=99b95bd4&"
import script from "./EmptyTable.vue?vue&type=script&lang=ts&"
export * from "./EmptyTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports